import { LandingPageSections } from '../LandingPage.types'

const meetUs: LandingPageSections[] = [
  {
    type: 'text',
    id: '9',
    desktopWidth: 'full',
    heading: 'Meet The Babylist Team',
    background: 'none',
    includeVerticalSectionSpacing: false,
  },
  {
    type: 'cards',
    id: '4',
    desktopWidth: 'limited',
    imageShape: 'mediumCircle',
    background: 'white',
    mobileVariant: 'stacked',
    desktopVariant: 'twoColumns',
    cards: [
      {
        type: 'card',
        id: '8',
        headerText:
          '<a href="/hello-baby/authors/karen-reardanz">Karen Reardanz</a>',
        subHeaderContent: 'Director, Editorial & Brand',
        body: "Karen Reardanz is the Director of Editorial & Brand at Babylist. She comes from a journalism background, covering food, lifestyle and entertainment for the San Francisco Chronicle and SFGATE, as well as Via magazine and StubHub. When she's not working with the teams that create trusted content that helps families on their new journey, she's on a parenting journey of her own to a human child and three feline ones. She loves to run, bake, travel and sleep.",
        imageUrl:
          'https://images.babylist.com/image/upload/w_150/v1692821278/Dynamic%20Landing%20Pages/KarenReardanz.jpg',
        altText: 'Karen Reardanz, Director Editorial & Brand',
      },
      {
        type: 'card',
        id: '10',
        headerText:
          '<a href="/hello-baby/authors/maddie-eisenhart">Maddie Eisenhart</a>',
        subHeaderContent: 'Senior Branded Content Editor',
        body: "Maddie Eisenhart is Babylist's Senior Branded Content Editor and mom of two—including a new baby who is reacquainting her with all of the gear that helps new parents survive those first precious months together. She lives in Maine with her partner and two boys, Lincoln and Rafael.",
        imageUrl:
          'https://images.babylist.com/image/upload/w_150/v1692821266/Dynamic%20Landing%20Pages/MaddieEisenhart.jpg',
        altText: 'Maddie Eisenhart, Senior Branded Content Editor',
      },
      {
        type: 'card',
        id: '11',
        headerText:
          '<a href="/hello-baby/authors/briana-engelbrecht">Briana Engelbrecht</a>',
        subHeaderContent: 'Assistant Editor',
        body: "Briana Engelbrecht is an assistant editor at Babylist, where she brings her passion for early childhood development and experience as a mom of two to Babylist articles and product guides. A former preschool teacher, she loves children's picture books, cats, plants and making things.",
        imageUrl:
          'https://images.babylist.com/image/upload/w_150/v1692821271/Dynamic%20Landing%20Pages/BrianaEngelbrecht.png',
        altText: 'Briana Engelbrecht, Assistant Editor',
      },
      {
        type: 'card',
        id: '12',
        headerText:
          '<a href="/hello-baby/authors/jennifer-labracio">Jennifer LaBracio</a>',
        subHeaderContent: 'Senior Gear Editor',
        body: "Jen LaBracio is Babylist's Senior Gear Editor, a role that perfectly combines her love of all things baby gear with her love of (obsessive) research. When she's not testing out a new high chair or pushing the latest stroller model around her neighborhood, she likes to run, spin, listen to podcasts, read and spend time at the beach. In her past life, she worked for over a decade in children's publishing. She lives in New Jersey with her husband and their two boys, Will and Ben.",
        imageUrl:
          'https://images.babylist.com/image/upload/w_150/v1692821266/Dynamic%20Landing%20Pages/JenniferLaBracio.jpg',
        altText: 'Jennifer Labracio, Senior Gear Editor',
      },
      {
        type: 'card',
        id: '13',
        headerText: '<a href="/hello-baby/authors/amylia-ryan">Amylia Ryan</a>',
        subHeaderContent: 'Associate Editor',
        imageUrl:
          'https://images.babylist.com/image/upload/w_150/v1692821268/Dynamic%20Landing%20Pages/AmyliaRyan.jpg',
        altText: 'Amylia Ryan, Associate Editor',
        body: 'Amylia Ryan is the Associate Editor at Babylist, where she writes and edits content on health, wellness, baby products and more. Before dedicating herself to helping new parents learn all about life with a baby, she worked in book publishing as an editor. She still sometimes edits books on the side, but the majority of her free time is dedicated to her two children.',
      },
      {
        type: 'card',
        id: '14',
        headerText:
          '<a href="/hello-baby/authors/alainna-wurfel">Alainna Wurfel</a>',
        subHeaderContent: 'Newsletter Editor',
        imageUrl:
          'https://images.babylist.com/image/upload/w_150/v1692821271/Dynamic%20Landing%20Pages/AlainnaWurfel.jpg',
        altText: 'Alainna Wurfel, Newsletter Editor',
        body: "Alainna Wurfel is Babylist's Newsletter Editor, a role that combines her enthusiasm for discovering new parenting tips and great baby gear with her love for writing. When she's not curating emails and creating content to support them, Alainna enjoys gardening, sewing and cooking. In past lives, she was an editor at The New York Times, The Wall Street Journal and Texas Monthly Magazine; and a marketing director at the design company Schumacher. She lives in Austin, TX with her husband and their toddler.",
      },
    ],
  },
]

export default meetUs
